import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';

const useStyles = makeStyles({
  root: {
    // background: 'linear-gradient(#87CEFA 0%, #6495ED 100%)',
    boxShadow: '0 4px 7px 3px rgba(0, 0, 255, .3)',
    padding: '0 30px',
    maxWidth: 500,
  },
});

export default function ProductCard(props) {
  const classes = useStyles();
  const [descriptionExpanded, setDescriptionExpanded] = useState(false);
  const [specificationExpanded, setSpecificationExpanded] = useState(false);

  const handleDescriptionExpandClick = () => {
    setDescriptionExpanded(!descriptionExpanded);
  };

  const handleSpecificationExpandClick = () => {
    setSpecificationExpanded(!specificationExpanded);
  };

  return (
    <div>
    <Card className={classes.root}>
      <CardMedia
        component="img"
        alt={props.alt}
        height="250"
        src={props.imageUrl}
        title={props.alt}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" color="textPrimary">
          {props.name}
        </Typography>
        <Button variant="outlined" color="primary" href={props.link}>
          Buy
        </Button>
        <br />
        <br />
        <Typography color="textPrimary" variant="body1">
        Price: {props.price}₹
            </Typography>
            <br />
        {/* Description Section */}
        {!descriptionExpanded && (
          <>
            <Typography color="textPrimary" variant="body1">
              Description:
            </Typography>
            <Typography
              color="textPrimary"
              variant="body1"
              component="div"
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {props.description.slice(0, 100)}{props.description.length > 100 && ('...')}
            </Typography>
          </>
        )}

        <Collapse in={descriptionExpanded} timeout="auto" unmountOnExit>
        <Typography color="textPrimary" variant="body1">
              Description:
            </Typography>          
          <Typography
            color="textPrimary"
            variant="body1"
            component="div"
            style={{ whiteSpace: 'pre-wrap' }}
          >
            {props.description}
          </Typography>
        </Collapse>
        {props.description.length > 100 && (
          <Button onClick={handleDescriptionExpandClick} color="primary">
            {descriptionExpanded ? 'Read Less' : 'Read More'}
          </Button>
        )}

        {/* Specification Section */}
        {!specificationExpanded && (
          <>
            <Typography color="textPrimary" variant="body2">
              Specification:
            </Typography>
            <Typography
              color="textPrimary"
              variant="body2"
              component="div"
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {props.specification.slice(0, 100)}{props.specification.length > 100 && ('...')}
            </Typography>
          </>
        )}

        <Collapse in={specificationExpanded} timeout="auto" unmountOnExit>
        <Typography color="textPrimary" variant="body2">
              Specification:
            </Typography>
          <Typography
            color="textPrimary"
            variant="body2"
            component="div"
            style={{ whiteSpace: 'pre-wrap' }}
          >
            {props.specification}
          </Typography>
        </Collapse>
        {props.specification.length > 100 && (
          <Button onClick={handleSpecificationExpandClick} color="primary">
            {specificationExpanded ? 'Read Less' : 'Read More'}
          </Button>
        )}
      </CardContent>
    </Card>
    </div>
  );
}
